<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>
            <div>
              <h1 class="title-view">Rate</h1>

              <div class="box-id">
                <div class="status-tab">
                  <div
                    class="badge-status text-status"
                    v-bind:class="getClassByRateStatus(rate.status)"
                  >
                    {{ formatRateStatus(rate.status) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              @click="changeMode('view')"
              class="min-button"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="changeMode('edit')"
              class="min-button"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              @click="saveRates()"
              class="min-button"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5 forms">
      <tabs
        tabNavClasses="tabs-home justify-content-around tab-profiles"
        :value="tabActive"
        @changeTabActive="changeTabActive"
        type="primary"
      >
        <tab-pane
          class="tabs-home-content"
          id="Overview"
          title="Overview"
          ref="Overview"
        >
          <div class="row">
            <div
              class="col-xl-9 col-lg-9 col-md-9 col-sm-8 col-12 box-flex"
              :class="{
                'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12':
                  rate.status === 'EXPIRED' || mode === 'view'
              }"
            >
              <div class="card p-not-action pb-2">
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Destination</span>
                      <span class="content-block">{{ destinationName }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 box-flex"
              v-if="mode === 'edit' && rate.status !== 'EXPIRED'"
            >
              <div class="card p-not-action pb-2">
                <div class="col-xl-12 text-center">
                  <h2 class="subtitle mb-0">
                    Active
                    <el-popover
                      placement="bottom"
                      trigger="hover"
                      width="350"
                      class="curp"
                    >
                      <span>
                        Activate to make it bookable and available to be
                        consumed via Services.
                      </span>
                      <div class="badge badge-primary" slot="reference">?</div>
                    </el-popover>
                  </h2>
                  <base-switch
                    v-model="rateStatus"
                    @input="changeRateStatus"
                  ></base-switch>
                  <span class="d-block" v-if="rate.status === 'EXPIRED'"
                    >Expired</span
                  >
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card p-not-action">
                <h2 class="subtitle">Vehicle Parameters</h2>

                <base-alert
                  v-if="vehicleList.length === 0"
                  type="secondary"
                  class="alert-box"
                  v-bind:class="{
                    'invalid-card': $v.rate.vehicles.$error
                  }"
                >
                  <h4><strong>Waiting search!</strong></h4>

                  Select a Destination to see the available vehicles

                  <img
                    src="~rhomtrip_assets/src/img/character/waiting.png"
                    alt="Rhomtrip waiting"
                    class="character-2"
                  />
                </base-alert>
                <div v-else>
                  <div v-if="loaderServ">
                    <div class="text-center p-5">
                      <h4><strong>Finding Vehicles...</strong></h4>

                      <div id="loaderInner">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    v-bind:class="{
                      'invalid-card br-2': $v.rate.vehicles.$error
                    }"
                  >
                    <b-table
                      v-if="mode === 'edit'"
                      hover
                      :items="vehicleList"
                      :fields="fields"
                      sort-by.sync="created_at"
                      sort-desc.sync="true"
                      selectable
                      @row-selected="onRowSelected"
                      select-mode="multi"
                      ref="selectableTable"
                      sort-icon-left
                      responsive
                      show-empty
                      empty-filtered-text="There are no records matching your request"
                      empty-text="There are no records to show"
                    >
                      <template #head()="{ label, field: { key } }">
                        <span v-if="key === 'selected'">
                          <span
                            @click="clearSelected"
                            v-if="selectedRows.length == vehicleList.length"
                            class="check-table selected"
                          ></span>

                          <span
                            @click="selectAllRows"
                            v-else
                            class="check-table"
                          ></span>
                        </span>
                        <span v-else>{{ label }}</span>
                      </template>
                      <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                          <span
                            aria-hidden="true"
                            class="check-table selected"
                          ></span>
                          <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                          <span aria-hidden="true" class="check-table"></span>
                          <span class="sr-only">Not selected</span>
                        </template>
                      </template>

                      <template #cell(category)="data">
                        <div class="box-img-card">
                          <div class="img-car">
                            <img
                              :src="data.item.vehicle.information.image"
                              class="img-fluid es-img-service-2"
                              alt="Service Car"
                            />
                          </div>

                          <div class="content">
                            <span class="username hide-data capitalize">
                              {{
                                formatCatergory(
                                  data.item.vehicle.parameters.category
                                )
                              }}
                              Class
                              {{ data.item.vehicle.parameters.n_seats }}
                              seats</span
                            >
                          </div>
                        </div>
                      </template>
                      <template #cell(type)="data">
                        {{
                          formatVehicleType(data.item.vehicle.parameters.type)
                        }}
                      </template>

                      <template #cell(model)="data">
                        {{ data.item.vehicle.parameters.name }} or similar
                      </template>

                      <template #cell(seats)="data">
                        {{ data.item.vehicle.parameters.n_seats }}
                      </template>

                      <template #cell(bags)="data">
                        {{ data.item.vehicle.parameters.n_suitcases }}
                      </template>

                      <template #cell(tags)="data">
                        <span>{{
                          getTagNames(data.item.vehicle.parameters.tags)
                        }}</span>
                      </template>
                    </b-table>

                    <div class="" v-else>
                      <div class="card">
                        <div class="col-xl-12" v-if="vehicle !== null">
                          <div class="row">
                            <div
                              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                            >
                              <div class="row card-serv-v card-select">
                                <div
                                  class="col-xl-2 col-md-2 col-sm-2 col-12 align-self-center"
                                >
                                  <img
                                    :src="vehicle.url"
                                    class="img-fluid es-img-service"
                                    alt="Service Car"
                                  />
                                </div>
                                <div
                                  class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12 align-self-center text-left pl-sm-0"
                                >
                                  <h2 class="title-serv">
                                    {{ formatCatergory(vehicle.category) }}
                                    Class

                                    {{ vehicle.n_seats }} seats
                                  </h2>

                                  <span class="type-card"
                                    >{{ vehicle.name }} or Similar</span
                                  >

                                  <div class="descrip">
                                    <span>
                                      <i class="flaticon-people-1"></i>
                                      Passengers: {{ vehicle.n_seats }}
                                    </span>

                                    <span>
                                      <i class="flaticon-briefcase"></i>
                                      Bags: {{ vehicle.n_suitcases }}
                                    </span>
                                  </div>
                                  <!-- tags block -->
                                  <div
                                    class="d-block mb-1"
                                    v-if="vehicle.tags.length > 0"
                                  >
                                    <span
                                      class="badge-tag"
                                      v-for="tag in vehicle.tags"
                                      :key="tag.ref"
                                    >
                                      {{ tag.name }}
                                    </span>
                                  </div>
                                  <!-- end tag block -->
                                </div>
                                <div
                                  class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 alinmov8 align-self-center"
                                >
                                  <div class="more-details">
                                    <ul class="mb-0">
                                      <li v-if="rate.preference.wifi">
                                        WiFi onboard
                                      </li>
                                      <li v-if="rate.preference.water">
                                        Water
                                      </li>
                                      <li v-if="rate.preference.hand_sanitizer">
                                        Hand Sanitizer
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div
                                  class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 alinmov9 align-self-center"
                                >
                                  <div>
                                    <span class="price title-serv">
                                      {{ rate.currency_symbol }}
                                      {{ rate.base_price }}
                                      {{ rate.currency_code }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-center p-0" v-else>
                          <div id="loaderInner">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <small
                  class="invalid-feedback mb-4"
                  v-if="$v.rate.vehicles.$error"
                  >Select Vehicle(s)</small
                >
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="Pricing"
          title="Pricing"
          ref="Pricing"
        >
          <div class="row profile" v-if="mode === 'edit'">
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
            >
              <div class="card">
                <h2 class="subtitle">Rate Parameters</h2>
                <div class="row mt-2">
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
                    <label class="title-label"
                      ><span class="markrequired">*</span>Pricing Selections
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span>
                          <strong>By Distance: </strong>For rides greater than
                          the Distance for rate calculation, RhomTrip will
                          calculate Base price + extra km.
                          <br />
                          <br />
                          <strong> Area + Distance:</strong> For rides less than
                          the Distance for rate calculation, RhomTrip will
                          calculate Area cost + extra km.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          <span>?</span>
                        </div>
                      </el-popover></label
                    >
                    <div class="option-transfers">
                      <b-form-group v-slot="{ ariaDescribedby2 }">
                        <b-form-radio-group
                          id="radio-group-1"
                          v-model="selectionRate"
                          :aria-describedby="ariaDescribedby2"
                          name="radio-options"
                          buttons
                          @change="changeSelectonRate(selectionRate)"
                          button-variant="group-neutral"
                          class="buttons-type"
                        >
                          <b-form-radio value="travel"
                            >By Distance</b-form-radio
                          >
                          <b-form-radio value="area"
                            >Area + Distance</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                    <WSelect
                      v-bind:class="{
                        'is-invalid': $v.rate.currency_code.$error
                      }"
                      placeholder="Currency"
                      v-model="$v.rate.currency_code.$model"
                      id="rate_currency"
                      name="rate_currency"
                      label="Currency"
                      markrequired
                      :error="
                        $v.rate.currency_code.$error ? `Select a Currency` : ''
                      "
                      @change="selectCurrencyCode"
                    >
                      <el-option
                        v-for="coin in coins"
                        :value="coin.code"
                        :label="coin.label"
                        :key="coin.code"
                      >
                        <div class="row">
                          <div class="col-7 align-self-center">
                            <span class="append-text">{{ coin.label }}</span>
                          </div>
                          <div class="col-5 text-right align-self-center">
                            <span class="prepend-text">{{ coin.symbol }}</span>
                          </div>
                        </div>
                      </el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                    <BaseNumberInput
                      v-model.number="$v.rate.base_price.$model"
                      label="Base Price"
                      placeholder="Base Price"
                      id="rate_basePrice"
                      name="rate_basePrice"
                      class="input-append-2 with-prepend"
                      markrequired
                      :error="
                        generateValidationMessage($v.rate.base_price, 'Price')
                      "
                    >
                      <template slot="prepend">{{
                        rate.currency_symbol
                      }}</template>
                      <template slot="append">{{
                        rate.currency_code
                      }}</template>
                    </BaseNumberInput>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                    <BaseNumberInput
                      v-model.number="$v.rate.price_extra_km.$model"
                      :label="`Price extra ${localUnit}`"
                      id="rate_extraPrice"
                      name="rate_extraPrice"
                      placeholder="Extra price"
                      class="input-append-2 with-prepend"
                      markrequired
                      :error="
                        generateValidationMessage(
                          $v.rate.price_extra_km,
                          'Price'
                        )
                      "
                    >
                      <template slot="prepend">{{
                        rate.currency_symbol
                      }}</template>
                      <template slot="append">{{
                        rate.currency_code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Hourly</h2>
                <div class="row mt-2">
                  <div class="col-12 pb-3">
                    <label class="title-label"
                      >Hourly Rate
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span>
                          Disable this option when the service does not offer
                          hourly rates
                          <br /><br />

                          <strong>Note: </strong>If hourly rates are disabled,
                          the system should not prompt for hourly rate details
                          during rate creation or editing.
                        </span>

                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover></label
                    >
                    <base-switch
                      class="sw-md mt-2 ml-3"
                      v-model="$v.rate.hours_disposition.status.$model"
                    ></base-switch>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="rate.hours_disposition.status"
                  >
                    <BaseNumberInput
                      label="Minimum"
                      v-model.number="
                        $v.rate.hours_disposition.min_hours.$model
                      "
                      id="hourly_min"
                      name="hourly_min"
                      placeholder="Minimum"
                      class="input-append-2"
                      :disabled="!rate.hours_disposition.status"
                      markrequired
                      :error="
                        minimumHoursValidationMessage(
                          $v.rate.hours_disposition.min_hours
                        )
                      "
                    >
                      <template slot="append">Hours</template>
                    </BaseNumberInput>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="rate.hours_disposition.status"
                  >
                    <BaseNumberInput
                      label="Maximum"
                      v-model.number="
                        $v.rate.hours_disposition.max_hours.$model
                      "
                      id="hourly_max"
                      name="hourly_max"
                      placeholder="Maximum"
                      class="input-append-2"
                      :disabled="!rate.hours_disposition.status"
                      :error="
                        maximunHoursValidationMessage(
                          $v.rate.hours_disposition.max_hours
                        )
                      "
                    >
                      <template slot="append">Hours</template>
                    </BaseNumberInput>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="rate.hours_disposition.status"
                  >
                    <BaseNumberInput
                      v-model.number="
                        $v.rate.hours_disposition.price_by_hour.$model
                      "
                      label="Price x hour"
                      id="rate_extraPrice"
                      name="rate_extraPrice"
                      placeholder="Extra price"
                      class="input-append-2 with-prepend"
                      markrequired
                      :disabled="!rate.hours_disposition.status"
                      :error="
                        generateValidationMessage(
                          $v.rate.hours_disposition.price_by_hour,
                          'Price'
                        )
                      "
                    >
                      <template slot="prepend">{{
                        rate.currency_symbol
                      }}</template>
                      <template slot="append">{{
                        rate.currency_code
                      }}</template>
                    </BaseNumberInput>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="rate.hours_disposition.status"
                  >
                    <BaseNumberInput
                      v-model.number="
                        $v.rate.hours_disposition.km_include.$model
                      "
                      :label="`${localUnit} inc. x hour`"
                      id="rate_extraPrice"
                      name="rate_extraPrice"
                      placeholder="Extra price"
                      class="input-append-2"
                      markrequired
                      :disabled="!rate.hours_disposition.status"
                      :error="
                        generateValidationMessage(
                          $v.rate.hours_disposition.km_include,
                          'Distance'
                        )
                      "
                    >
                      <template slot="append">{{ localUnit }}</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Child Seat</h2>
                <div class="row mt-2">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <BaseNumberInput
                      v-model.number="$v.rate.child_seat.number.$model"
                      mode="integer"
                      label="N° Seats"
                      placeholder="Seats"
                      id="number_chilseat"
                      name="number_chilseat"
                      :error="
                        $v.rate.child_seat.number.$error
                          ? `Enter a N° Seats`
                          : ''
                      "
                    />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <BaseNumberInput
                      v-model.number="$v.rate.child_seat.price.$model"
                      label="Price"
                      placeholder="Price"
                      id="price_childseat"
                      name="price_childseat"
                      class="input-append-2 with-prepend"
                      :error="
                        !$v.rate.child_seat.price.decimal ||
                        $v.rate.child_seat.price.$error
                          ? `Enter a Price`
                          : ''
                      "
                    >
                      <template slot="prepend">{{
                        rate.currency_symbol
                      }}</template>
                      <template slot="append">{{
                        rate.currency_code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Meet & Greet</h2>
                <div class="row mt-2">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <BaseNumberInput
                      label="Price"
                      v-model.number="$v.rate.meet_greet_price.$model"
                      placeholder="Price"
                      id="meet_greet_price"
                      name="meet_greet_price"
                      class="input-append-2 with-prepend"
                      :error="
                        !$v.rate.meet_greet_price.decimal ||
                        $v.rate.meet_greet_price.$error
                          ? `Enter a Price`
                          : ''
                      "
                    >
                      <template slot="prepend">{{
                        rate.currency_symbol
                      }}</template>
                      <template slot="append">{{
                        rate.currency_code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Preferences</h2>
                <div class="row">
                  <div class="col-12 align-self-center">
                    <base-checkbox v-model="$v.rate.preference.wifi.$model"
                      >Wifi</base-checkbox
                    >
                    <base-checkbox v-model="$v.rate.preference.water.$model"
                      >Water</base-checkbox
                    >
                    <base-checkbox
                      v-model="$v.rate.preference.hand_sanitizer.$model"
                      >Hand Sanitizer</base-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row profile" v-else>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
            >
              <div class="card">
                <h2 class="subtitle">Rate Parameters</h2>
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Pricing Selections</span>
                      <span class="content-block">{{
                        formatRateType(selectionRate)
                      }}</span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Currency</span>
                      <span class="content-block"
                        >{{ rate.currency_label }} -
                        {{ rate.currency_symbol }}</span
                      >
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Base Price</span>
                      <span class="content-block">
                        {{ rate.currency_symbol }}
                        {{ rate.base_price }}
                        {{ rate.currency_code }}
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block"
                        >Price extra {{ localUnit }}</span
                      >
                      <span class="content-block">
                        {{ rate.currency_symbol }}
                        {{ rate.price_extra_km }}
                        {{ rate.currency_code }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Hourly</h2>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="data-block">
                      <span class="title-block">Hourly Rate</span>
                      <span class="content-block">
                        {{ getStatusHourlyRate(rate.hours_disposition.status) }}
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Minimum</span>
                      <span class="content-block">
                        {{
                          rate.hours_disposition.min_hours
                            ? rate.hours_disposition.min_hours
                            : 0
                        }}
                        Hours
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Maximum</span>
                      <span class="content-block">
                        {{
                          rate.hours_disposition.max_hours
                            ? rate.hours_disposition.max_hours + " Hours"
                            : "No Limits"
                        }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 box-flex"
                  >
                    <div class="data-block">
                      <span class="title-block">Price x hour</span>
                      <span class="content-block">
                        {{ rate.currency_symbol }}
                        {{
                          rate.hours_disposition.price_by_hour
                            ? rate.hours_disposition.price_by_hour
                            : 0
                        }}
                        {{ rate.currency_code }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 box-flex"
                  >
                    <div class="data-block">
                      <span class="title-block"
                        >{{ localUnit }} inc. x hour</span
                      >
                      <span class="content-block">
                        {{
                          rate.hours_disposition.km_include
                            ? rate.hours_disposition.km_include
                            : 0
                        }}
                        {{ localUnit }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Child Seat</h2>
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">N° Seats</span>
                      <span class="content-block">
                        {{ rate.child_seat.number }}
                      </span>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Price</span>
                      <span class="content-block">
                        {{ rate.currency_symbol }}
                        {{ rate.child_seat.price }}
                        {{ rate.currency_code }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Meet & Greet</h2>
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Price</span>
                      <span class="content-block">
                        {{ rate.currency_symbol }}
                        {{ rate.meet_greet_price }}
                        {{ rate.currency_code }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card">
                <h2 class="subtitle">Preferences</h2>
                <div class="row">
                  <div class="col-12 align-self-center">
                    <div class="card-serv card-select no-shadow">
                      <div class="more-details">
                        <ul>
                          <li v-if="rate.preference.wifi">WiFi onboard</li>
                          <li v-if="rate.preference.water">Water</li>
                          <li v-if="rate.preference.hand_sanitizer">
                            Hand Sanitizer
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="Service-areas"
          :title="`Service Areas (${rate.area_of_action.length})`"
          ref="Service Areas"
          v-if="selectionRate === 'area'"
        >
          <div
            class="card"
            v-if="selectionRate === 'area'"
            :class="{ 'invalid-card': $v.rate.area_of_action.$error }"
          >
            <div class="row mb-2">
              <div class="col-6 align-self-center">
                <h2 class="subtitle mb-0">Service Areas</h2>
              </div>
              <div class="col-6 alinmov2 align-self-center">
                <base-button
                  type="outline-secondary"
                  class="min-button"
                  @click="addNewArea()"
                  v-if="mode === 'edit'"
                >
                  <i class="flaticon-plus"></i> Add new
                </base-button>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mb-4" v-if="rate.area_of_action.length === 0">
                <base-alert type="warning" class="mb-1 info-min">
                  <i class="flaticon-warning mr-1"></i> There are no service
                  areas here
                </base-alert>
              </div>
            </div>
            <div v-if="rate.area_of_action.length">
              <b-table
                hover
                :items="areasOptions"
                :fields="fieldsServicesAreas"
                sort-by.sync="created_at"
                sort-desc.sync="true"
                selectable
                select-mode="single"
                ref="tableServicesAreas"
                sort-icon-left
                responsive
                show-empty
                empty-filtered-text="There are no records matching your request"
                empty-text="There are no records to show"
              >
                <template #cell(areaCode)="data">
                  {{ data.item.areaCode }}
                </template>

                <template #cell(description)="data">
                  <span class="multiline-3">{{ data.item.description }}</span>
                </template>

                <template #cell(baseprice)="data">
                  <span
                    >{{ rate.currency_symbol }} {{ data.item.baseprice }}
                    {{ rate.currency_code }}</span
                  >
                </template>

                <template #cell(priceextra)="data">
                  <span
                    >{{ rate.currency_symbol }} {{ data.item.priceextra }}
                    {{ rate.currency_code }}</span
                  >
                </template>

                <template #cell(actions)="data" v-if="mode === 'edit'">
                  <el-tooltip content="Edit Area" placement="top">
                    <span
                      class="icon-action"
                      @click="
                        editArea(
                          data.item.area,
                          getIndexByAreaId(data.item._id, rate.area_of_action)
                        )
                      "
                    >
                      <i class="flaticon-pencil text-primary"></i>
                    </span>
                  </el-tooltip>

                  <el-tooltip content="Delete Area" placement="top">
                    <span
                      class="icon-action text-danger ml-2"
                      @click="
                        deleteArea(
                          getIndexByAreaId(data.item._id, rate.area_of_action)
                        )
                      "
                    >
                      <i class="flaticon-delete"></i>
                    </span>
                  </el-tooltip>
                </template>
              </b-table>
            </div>

            <NewArea
              :show="showNewAreaModal"
              @closeNewAreaModal="closeNewAreaModal"
              @addArea="createArea"
              :areas="areas"
              :currencySymbol="rate.currency_symbol"
              :currencyCode="rate.currency_code"
              :localUnit="localUnit"
            />
            <EditArea
              :show="showEditAreaModal"
              @closeEditAreaModal="closeEditAreaModal"
              @updateArea="updateArea"
              :selectedArea="area"
              :areas="areas"
              :currencySymbol="rate.currency_symbol"
              :currencyCode="rate.currency_code"
              :localUnit="localUnit"
            />
          </div>

          <small
            class="invalid-feedback mb-4"
            v-if="$v.rate.area_of_action.$error"
            >Add minimum 1 item</small
          >
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="especial_conditions"
          :title="`Especial Conditions (${surcharges.length})`"
          ref="especial_conditions"
        >
          <div class="card">
            <div class="row mb-2">
              <div class="col-6 align-self-center">
                <h2 class="subtitle mb-0">Especial Conditions</h2>
              </div>
              <div class="col-6 alinmov2 align-self-center">
                <base-button
                  type="outline-secondary"
                  class="min-button"
                  @click="createSurcharge"
                  v-if="mode === 'edit'"
                >
                  <i class="flaticon-plus"></i> Add new
                </base-button>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mb-4" v-if="surcharges.length === 0">
                <base-alert type="warning" class="mb-1 info-min">
                  <i class="flaticon-warning mr-1"></i> There are no Especial
                  Conditions here
                </base-alert>
              </div>
            </div>

            <div v-if="surcharges.length">
              <b-table
                hover
                :items="surchargesOptions"
                :fields="fieldsSurcharges"
                sort-by.sync="created_at"
                sort-desc.sync="true"
                selectable
                select-mode="single"
                ref="tableSurcharge"
                sort-icon-left
                responsive
                show-empty
                empty-filtered-text="There are no records matching your request"
                empty-text="There are no records to show"
              >
                <template #cell(event)="data">
                  {{ formatEventType(data.item.surcharge.type) }}
                </template>

                <template #cell(markupType)="data">
                  <span v-if="data.item.surcharge.type !== 'blackouts'">{{
                    formatSurcharge(data.item.surcharge.markup.type)
                  }}</span>
                  <span v-else>N/A</span>
                </template>

                <template #cell(description)="data">
                  <span class="multiline-3">{{
                    data.item.surcharge.description
                  }}</span>
                </template>

                <template #cell(value)="data">
                  <span v-if="data.item.surcharge.type !== 'blackouts'">{{
                    data.item.surcharge.markup.value
                  }}</span>
                  <span v-else>N/A</span>
                </template>

                <template #cell(from)="data">
                  <span v-if="isThereAnExpirationDate(data.item.surcharge.type)">
                    {{ getFormatDate(data.item.surcharge.from_date) }}
                    <span
                      class="d-block"
                      v-if="hasSurchargeTimeRange(data.item.surcharge.type)"
                      >{{ data.item.surcharge.start_time }}</span
                    >
                  </span>
                  <span v-else-if="hasSurchargeTimeRange(data.item.surcharge.type)">{{
                    data.item.surcharge.start_time
                  }}</span>
                  <span v-else>N/A</span>
                </template>

                <template #cell(end)="data">
                  <span v-if="isThereAnExpirationDate(data.item.surcharge.type)">
                    {{ getFormatDate(data.item.surcharge.to_date) }}
                    <span
                      class="d-block"
                      v-if="hasSurchargeTimeRange(data.item.surcharge.type)"
                      >{{ data.item.surcharge.end_time }}</span
                    >
                  </span>
                  <span v-else-if="hasSurchargeTimeRange(data.item.surcharge.type)">{{
                    data.item.surcharge.end_time
                  }}</span>
                  <span v-else>N/A</span>
                </template>

                <template #cell(status)="data">
                  <div
                    class="badge-status badge-success"
                    v-if="data.item.surcharge.status == true"
                  >
                    <span>Active</span>
                  </div>

                  <div class="badge-status badge-danger" v-else>
                    <span>Inactive</span>
                  </div>
                </template>

                <template #cell(actions)="data" v-if="mode === 'edit'">
                  <el-tooltip content="Edit" placement="top">
                    <span
                      class="icon-action text-blue"
                      @click="
                        updateSurcharge(
                          data.item.surcharge,
                          getSurchargeById(data.item._id, surcharges)
                        )
                      "
                    >
                      <i class="flaticon-pencil text-primary"></i>
                    </span>
                  </el-tooltip>
                  <el-tooltip content="Change status" placement="bottom">
                    <span
                      class="icon-action text-info ml-2"
                      @click.stop="
                        changeSurchargeStatus(
                          data.item.surcharge._id,
                          !data.item.surcharge.status,
                          getSurchargeById(data.item._id, surcharges)
                        )
                      "
                    >
                      <i class="flaticon-right-4"></i>
                    </span>
                  </el-tooltip>

                  <el-tooltip content="Delete" placement="top">
                    <span
                      class="icon-action text-danger ml-2"
                      @click="
                        deleteSurcharge(
                          data.item.surcharge._id,
                          getSurchargeById(data.item._id, surcharges)
                        )
                      "
                    >
                      <i class="flaticon-delete"></i>
                    </span>
                  </el-tooltip>
                </template>
              </b-table>

              <div class="col-md-12 pb-2 text-center no-desk">
                <el-tooltip content="Add" placement="top">
                  <base-button
                    type="primary"
                    class="btn-icon-only"
                    @click="createSurcharge()"
                  >
                    <i class="flaticon-plus"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </div>

            <SurchargeForm
              :show="openModalAddSurcharge"
              :timezone="timezone"
              :limit="surchargesLimit"
              :surchargeId="surchargeId"
              @addSurcharge="addSurchargeEvent"
              @closeSurchargeModal="closeSurchargeModal"
            />

            <SurchargeForm
              :show="openModalEditSurcharge"
              :payload="surcharge"
              :limit="surchargesLimit"
              :timezone="timezone"
              @surchargeEdit="editSurchargeEvent"
              @closeSurchargeModal="closeSurchargeModal"
            />
          </div>
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="Settings"
          title="Settings"
          ref="Settings"
        >
          <div class="row" v-if="mode === 'edit'">
            <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card p-not-action">
                <div class="row forms">
                  <div
                    class="col-12 mb-3 align-self-center"
                    v-bind:class="{
                      'is-invalid': $v.rate.keyDetails.$error
                    }"
                  >
                    <h2 class="subtitle">Key Details</h2>

                    <el-input
                      v-model="$v.rate.keyDetails.$model"
                      placeholder="Special Requirements"
                      id="keyDetails"
                      name="keyDetails"
                      maxlength="1500"
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 10 }"
                      show-word-limit
                    >
                    </el-input>

                    <small
                      class="invalid-feedback"
                      v-if="
                        !$v.rate.keyDetails.minLength ||
                        $v.rate.keyDetails.$error
                          ? `Enter from${$v.rate.keyDetails.$params.minLength.min} and to ${$v.rate.keyDetails.$params.maxLength.max} letters.`
                          : ''
                      "
                      >Enter the Key Details</small
                    >
                  </div>
                </div>
              </div>

              <div
                class="card p-not-action"
                :class="
                  $v.rate.cancellationPolicy.refundEligibility.$error
                    ? 'invalid-card'
                    : ''
                "
              >
                <div class="row forms">
                  <div class="col-6 mb-3 align-self-center">
                    <h2 class="subtitle mb-0">Cancellation Policy</h2>
                  </div>
                  <div class="col-6 text-right align-self-center">
                    <base-button
                      type="link"
                      class="min-button p-0 mb-3"
                      @click="addCancellationPolicy"
                    >
                      <i class="flaticon-plus"></i> Add More
                    </base-button>
                  </div>
                  <div class="col-12 mb-4">
                    <base-checkbox
                      v-model="rate.cancellationPolicy.nonRefundable"
                      @input="selectNonRefundable"
                      >Non-refundable</base-checkbox
                    >
                  </div>
                  <div class="col-12">
                    <draggable
                      v-if="
                        $v.rate.cancellationPolicy.refundEligibility.$model
                          .length
                      "
                      tag="ul"
                      :list="
                        $v.rate.cancellationPolicy.refundEligibility.$model
                      "
                      class="list-group"
                    >
                      <li
                        class="col-12 draggable-left pl-3 pr-0"
                        v-for="(element, idx) in $v.rate.cancellationPolicy
                          .refundEligibility.$each.$iter"
                        :key="idx"
                      >
                        <div
                          class="row"
                          v-if="
                            !['NON_REFUNDABLE', 'NO_REFUND'].includes(
                              element.type.$model
                            )
                          "
                        >
                          <div
                            class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 pr-0"
                          >
                            <WSelect
                              placeholder="Select Cancellation"
                              v-model="element.type.$model"
                              :id="`option${idx}`"
                              name="cancellationsItem"
                              label="Policy"
                              @input="selectPolicy(element)"
                              :error="element.type.$error ? 'Enter Policy' : ''"
                            >
                              <el-option
                                v-for="(item, index) in cancellationOptions"
                                :label="item.label"
                                :value="item.value"
                                :disabled="
                                  getItemDisable(item, rate.cancellationPolicy)
                                "
                                :key="index"
                              ></el-option>
                            </WSelect>
                          </div>

                          <div
                            class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 pr-0"
                          >
                            <WSelect
                              placeholder="Select Time"
                              v-model="element.unit.$model"
                              :id="`cancellationUnit${idx}`"
                              name="cancellationsItem"
                              label="Time"
                              @change="selectUnit"
                            >
                              <el-option
                                v-for="(item, index) in times"
                                :label="item.label"
                                :value="item.value"
                                :key="index"
                              ></el-option>
                            </WSelect>
                          </div>

                          <div
                            class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 pr-0 align-self-center"
                          >
                            <BaseNumberInput
                              v-model.number="element.cutoff.$model"
                              :label="
                                `N° ${getUnitFormatToLabel(
                                  element.unit.$model
                                )}`
                              "
                              placeholder="cancellationValue"
                              :id="`cancellationValue${idx}`"
                              name="cancellationsItem"
                              @change="selectCutoff"
                            />
                          </div>

                          <div
                            class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-6 pr-0 align-self-center"
                          >
                            <BaseNumberInput
                              v-model.number="element.percent.$model"
                              label="Percent"
                              placeholder="Percentage"
                              :id="`Percentage${idx}`"
                              name="cancellationsItem"
                              class="input-append-2"
                              :disabled="
                                element.type.$model !== 'PARTIAL_REFUND'
                              "
                              :error="
                                element.percent.$error
                                  ? 'Enter valid percent'
                                  : ''
                              "
                              @change="selectPercent"
                            >
                              <template slot="append">%</template>
                            </BaseNumberInput>
                          </div>

                          <div
                            class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 pr-md-0 align-self-center alinmov1"
                          >
                            <el-tooltip content="Delete" placement="bottom">
                              <span
                                class="icon-action mb-sm-4 mb-0"
                                @click="removeCancellation(idx)"
                              >
                                <i class="flaticon-delete text-danger"></i>
                              </span>
                            </el-tooltip>
                          </div>
                        </div>
                      </li>
                    </draggable>
                    <base-alert
                      type="warning"
                      class="info-min"
                      v-if="
                        !rate.cancellationPolicy.refundEligibility.length &&
                          !rate.cancellationPolicy.nonRefundable
                      "
                    >
                      <i class="flaticon-warning mr-1"></i>
                      There are currently no cancellation policy added.
                    </base-alert>
                  </div>
                </div>

                <div
                  class="card border"
                  v-if="
                    rate.cancellationPolicy.refundEligibility.length ||
                      rate.cancellationPolicy.nonRefundable
                  "
                >
                  <h3 class="subtitle">
                    Cancellation Info
                    <el-popover
                      placement="bottom"
                      trigger="hover"
                      width="350"
                      class="curp"
                    >
                      <span>
                        This content will be shown in all media: Website,
                        emails, vouchers.
                      </span>
                      <div class="badge badge-primary" slot="reference">?</div>
                    </el-popover>
                  </h3>
                  <ul class="list-cancellations">
                    <li
                      v-for="(element, index) in $v.rate.cancellationPolicy
                        .refundEligibility.$each.$iter"
                      :key="index"
                    >
                      {{ getDescription(element.$model) }}
                    </li>
                  </ul>
                </div>
              </div>
              <small
                class="invalid-feedback mb-3 mt--1"
                v-if="$v.rate.cancellationPolicy.refundEligibility.$error"
                >Add minimum 1 cancellation policy</small
              >

              <div class="card p-not-action">
                <div class="row forms">
                  <div
                    class="col-12 mb-3 align-self-center"
                    v-bind:class="{
                      'is-invalid': $v.rate.termsConditions.$error
                    }"
                  >
                    <h2 class="subtitle">Terms and Conditions</h2>

                    <el-input
                      v-model="$v.rate.termsConditions.$model"
                      placeholder="Special Requirements"
                      id="termsconditions"
                      name="termsconditions"
                      maxlength="1500"
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 10 }"
                      show-word-limit
                    >
                    </el-input>

                    <small
                      class="invalid-feedback"
                      v-if="
                        !$v.rate.termsConditions.minLength ||
                        $v.rate.termsConditions.$error
                          ? `Enter from${$v.rate.termsConditions.$params.minLength.min} and to ${$v.rate.termsConditions.$params.maxLength.max} letters.`
                          : ''
                      "
                      >Enter the Terms and Conditions</small
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div
                  class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card p-not-action">
                    <h2 class="subtitle mb-3">
                      Validity
                      <el-popover placement="top" trigger="hover" width="300">
                        <p class="form-control-label mb-2"></p>

                        <p class="content-tooltip">
                          The start date must be equal to or greater than today
                          <strong>{{ today }}</strong
                          >, and the end date must be greater than the start
                          date
                        </p>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </h2>
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          label="Start Date"
                          :error="
                            startDateValidationMessage(
                              $v.rate.validity_date.start
                            )
                          "
                          markrequired
                        >
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur"
                            :config="{
                              altFormat: 'd-M-Y',
                              altInput: true,
                              dateFormat: 'Y-m-d',
                              allowInput: true
                            }"
                            class="input-custom"
                            v-model="$v.rate.validity_date.start.$model"
                            @input="changetValidityStartDate"
                            id="Start_Date"
                            name="Start_Date"
                            placeholder="Start Date"
                          ></flat-picker>
                        </base-input>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          label="End Date"
                          :error="
                            endDateValidationMessage($v.rate.validity_date.end)
                          "
                          markrequired
                        >
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur"
                            :config="{
                              altFormat: 'd-M-Y',
                              altInput: true,
                              dateFormat: 'Y-m-d',
                              allowInput: true
                            }"
                            class="input-custom"
                            v-model="$v.rate.validity_date.end.$model"
                            id="End_Date"
                            name="End_Date"
                            placeholder="End Date"
                          ></flat-picker>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card p-not-action">
                    <h2 class="subtitle mb-3">Advanced Reservation</h2>
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-7 col-sm-6 col-12">
                        <WSelect
                          v-bind:class="{
                            'is-invalid':
                              $v.rate.advancedReservation.cutoff.$error
                          }"
                          placeholder="Select hours"
                          v-model="$v.rate.advancedReservation.cutoff.$model"
                          id="branch_Advance"
                          name="branch_Advance"
                          label="Minimum Hours"
                          :error="
                            $v.rate.advancedReservation.cutoff.$error
                              ? `Enter Hours`
                              : ''
                          "
                          markrequired
                        >
                          <el-option
                            v-for="option in advancedReservationHours"
                            :value="option"
                            :label="option"
                            :key="option"
                          ></el-option>

                          <template slot="suffix">Hours</template>
                        </WSelect>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row profile" v-else>
            <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card p-not-action">
                <h2 class="subtitle mb-3">Key Details</h2>
                <div v-if="rate.keyDetails">
                  <div class="data-block">
                    <span class="content-block">{{ rate.keyDetails }}</span>
                  </div>
                </div>

                <base-alert type="warning" class="info-min" v-else>
                  <i class="flaticon-warning mr-1"></i>
                  There are currently no key details added.
                </base-alert>
              </div>

              <div class="card p-not-action">
                <h2 class="subtitle mb-3">Cancellation Policy</h2>
                <div
                  v-if="
                    $v.rate.cancellationPolicy.refundEligibility.$model.length
                  "
                >
                  <ul class="list-cancellations">
                    <li
                      v-for="(element, idx) in rate.cancellationPolicy
                        .refundEligibility"
                      :key="idx"
                    >
                      {{ getDescription(element) }}
                    </li>
                  </ul>
                </div>
                <base-alert type="warning" class="info-min" v-else>
                  <i class="flaticon-warning mr-1"></i>
                  There are currently no cancellation policy added.
                </base-alert>
              </div>

              <div class="card p-not-action" v-if="rate.termsConditions">
                <h2 class="subtitle mb-3">Terms and Conditions</h2>
                <div>
                  <div class="data-block">
                    <span class="content-block">{{
                      rate.termsConditions
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div
                  class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card p-not-action">
                    <h2 class="subtitle">Validity</h2>
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Start Date</span>
                          <span class="content-block">{{
                            getDateFormat(rate.validity_date.start)
                          }}</span>
                        </div>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">End Date</span>
                          <span class="content-block">{{
                            getDateFormat(rate.validity_date.end)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card p-not-action">
                    <h2 class="subtitle mb-3">Advanced Reservation</h2>

                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Minimum Hours</span>
                          <span class="content-block">{{
                            rate.advancedReservation.cutoff
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import { joinTagNames } from "../../../helpers/tags.helpers";
import localHelper from "../commons/Helper";
import lodash from "lodash";
import WSelect from "@/components/Select";
import NewArea from "../components/Area/NewArea";
import EditArea from "../components/Area/EditArea";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import draggable from "vuedraggable";
import {
  minimumSelect,
  coins,
  fields,
  fieldsSurcharges,
  fieldsServicesAreas,
  times,
  cancellationOptions,
  selectsHours,
  termsConditions
} from "../commons/util/data";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
import {
  required,
  decimal,
  numeric,
  requiredIf,
  minValue,
  maxValue,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import {
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Checkbox,
  Switch,
  Card
} from "element-ui";
import Swal from "sweetalert2";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";
import {
  endDateValidationMessage,
  generateValidationMessage,
  maximunHoursValidationMessage,
  minimumHoursValidationMessage,
  startDateValidationMessage
} from "../services/validation.service";
import SurchargeForm from "../components/SurchargeForm";
import { hasSurchargeTimeRange } from "../services/format.service";

export default {
  name: "EditRates",
  data() {
    return {
      rate: {
        branch: "",
        type_of_quote: "travel",
        vehicle: "",
        vehicles: [],
        hand_luggage: 5,
        base_price: 0,
        price_extra_km: 0,
        hours_disposition: {
          status: false,
          min_hours: null,
          max_hours: null,
          price_by_hour: null,
          km_include: null
        },
        currency_code: "",
        currency_symbol: "",
        currency_label: "",
        child_seat: {
          price: 0,
          number: 0
        },
        preference: {
          wifi: false,
          water: false,
          newspaper: false,
          hand_sanitizer: false
        },
        meet_greet_price: 0,
        area_of_action: [],
        surcharges: [],
        relationship: {
          owner: null,
          type: "supplier"
        },
        status: "ACTIVE",
        validity_date: {
          start: "",
          end: ""
        },
        cancellationPolicy: {
          nonRefundable: false,
          type: "STANDARD",
          refundEligibility: [],
          descriptions: []
        },
        notifications: {
          remind_supplier_expiry: false
        },
        advancedReservation: {
          unit: "HOURS",
          cutoff: 1
        },
        keyDetails: "",
        termsConditions: termsConditions
      },
      vehicle: {
        n_seats: 0,
        n_suitcases: 0,
        url: require("rhomtrip_assets/src/img/no-preview.png"),
        category: "",
        tags: []
      },
      minimumSelect: minimumSelect,
      coordinates: [],
      img: require("rhomtrip_assets/src/img/no-preview.png"),
      loading: false,
      options: [],
      selectionRate: "travel",
      rateCopy: {},
      saved: false,
      coins: coins,
      ///Surcharges
      openModalAddSurcharge: false,
      surcharges: [],
      openModalEditSurcharge: false,
      surcharge: null,
      index_surcharge: -1,
      timezone: "",
      surchargesLimit: [],
      vehiclesOptions: [],
      tempUnit: "km",
      rateId: null,
      fields: fields,
      selectedRows: [],
      fieldsSurcharges: fieldsSurcharges,
      mode: "view",
      tabActive: "Overview",
      destinationName: "",
      loaderServ: false,
      fieldsServicesAreas: fieldsServicesAreas,
      area: null,
      areaIndex: -1,
      showNewAreaModal: false,
      showEditAreaModal: false,
      rateStatus: true,
      maxSurchargeLimit: 20,
      surchargeId: null,
      lastValidityStartDate: "",
      lastValidityEndDate: "",
      lastStatus: "",
      today: moment().format("DD-MMM-YYYY"),
      times: times,
      cancellationOptions: cancellationOptions,
      advancedReservationHours: selectsHours,
      hourlyRates: true
    };
  },
  async created() {
    var bread = [
      {
        text: "Rates",
        to: "/rates"
      },

      {
        text: "Rate Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.rateId = this.$route.params.id;
    this.getBranchesOptions();
    await this.getRateById(this.rateId);
  },
  methods: {
    /**
     * Get the names of the vehicle tags to display them in a single line.
     * @param {Object[]} tags - The vehicle tags ({ ref, name, slug }).
     * @returns {string} The tag names separated by " | ".
     */
    getTagNames(tags = []) {
      return joinTagNames(tags);
    },
    startDateValidationMessage,
    endDateValidationMessage,
    maximunHoursValidationMessage,
    minimumHoursValidationMessage,
    generateValidationMessage,
    async getRateById(rateId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.getRateById(
          rateId,
          this.sesion.token
        );
        if (data) {
          let rate = data;
          this.rate.branch = rate.branch._id;
          this.rate.status = rate.status;
          this.rateStatus = rate.status === "ACTIVE";
          this.lastStatus = rate.status;
          this.vehicles = await this.getVehiclesByBranchId(rate.branch._id);
          this.vehiclesOptions = this.populateVehicles(this.vehicles);
          this.areas = await this.getAreasOptionsByBranchId(rate.branch._id);
          this.getSettings(rate.branch.supplier._id);
          this.timezone = rate.branch.timezone;
          this.rate.preference.wifi = rate.preference.wifi;
          this.rate.preference.water = rate.preference.water;
          this.rate.preference.hand_sanitizer = rate.preference.hand_sanitizer;
          this.rate.preference.newspaper = rate.preference.newspaper;
          this.rate.hours_disposition = rate.hours_disposition;
          this.rate.base_price = rate.base_price;
          this.rate.vehicles = rate.vehicles;
          this.rate.surcharges = rate.surcharges;
          this.surcharges = this.rate.surcharges;
          this.rate.price_extra_km = rate.price_extra_km;
          this.rate.area_of_action = rate.area_of_action;
          this.rate.child_seat.price = rate.child_seat.price;
          this.rate.child_seat.number = rate.child_seat.number;
          this.rate.meet_greet_price = rate.meet_greet_price
            ? rate.meet_greet_price
            : 0;

          this.rate.type_of_quote = rate.type_of_quote;
          this.selectionRate = rate.type_of_quote;
          /**
           *
           */
          this.rate.currency_code = rate.currency_code;
          this.rate.currency_symbol = rate.currency_symbol;
          this.rate.currency_label = rate.currency_label;
          this.rate.vehicle = rate.vehicle._id;

          this.rate.relationship.owner = rate.relationship.owner;
          this.rate.relationship.type = rate.relationship.type;

          this.rate.validity_date.start = this.getDate(
            rate.validity_date.start
          );
          this.rate.validity_date.end = this.getDate(rate.validity_date.end);
          this.rate.cancellationPolicy = lodash.cloneDeep(
            rate.cancellationPolicy
          );
          this.rate.advancedReservation = lodash.cloneDeep(
            rate.advancedReservation
          );

          this.rate.keyDetails = rate.keyDetails;

          this.rate.termsConditions = rate.termsConditions;

          this.lastValidityStartDate = this.rate.validity_date.start;
          this.lastValidityEndDate = this.rate.validity_date.end;
          this.rate.notifications.remind_supplier_expiry =
            rate.notifications.remind_supplier_expiry;

          this.rateCopy = lodash.cloneDeep(this.rate);

          this.surchargesLimit = rate.surcharges.map(element => {
            return { _id: element._id, type: element.type };
          });

          this.vehicle.n_seats = rate.vehicle.parameters.n_seats;
          this.vehicle.n_suitcases = rate.vehicle.parameters.n_suitcases;
          this.vehicle.url = rate.vehicle.information.image;
          this.vehicle.category = rate.vehicle.parameters.category;
          this.vehicle.name = rate.vehicle.parameters.name;
          this.vehicle.tags = rate.vehicle.parameters.tags || [];

          this.destinationName = rate.branch.name;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
        this.setLoad(false);
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error loading the data. Please try again"
        );
      }
    },
    changeSelectonRate(origin) {
      this.rate.type_of_quote = value;
    },
    async updateRate(rateId, rate, route = null) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.updateRateById(
          rateId,
          rate,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rate has been Updated",
            icon: "flaticon-check-3"
          });
          if (route) {
            this.$router.push(route);
          } else {
            this.mode = "view";
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.saved = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async saveRates(route = null) {
      if (!this.$v.rate.$invalid) {
        let rate = lodash.cloneDeep(this.rate);
        rate.area_of_action = this.parseAreaOfAction(rate.area_of_action);
        rate.surcharges = this.surcharges.map(surcharge => surcharge._id);
        rate.cancellationPolicy.refundEligibility = this.sortRefundEligibility(
          rate.cancellationPolicy.refundEligibility
        );
        rate.cancellationPolicy.descriptions = this.getItemsDescriptionByRefundEligibility(
          rate.cancellationPolicy.refundEligibility
        );
        await this.updateRate(this.rateId, rate, route);
      } else {
        this.$v.rate.$touch();
        let { overviwe, pricing, areas, settings } = this.validateRate(
          this.$v.rate
        );
        this.goToTab(overviwe, pricing, areas, settings);
      }
    },
    createSurcharge() {
      if (this.rate.branch) {
        if (this.surchargesLimit.length < this.maxSurchargeLimit) {
          this.openModalAddSurcharge = !this.openModalAddSurcharge;
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message: `You have exceeded the maximum number of extra surcharge events which is ${this.maxSurchargeLimit}.`,
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Warning!",
          message: "Please select a destination",
          icon: "flaticon-warning-1"
        });
      }
    },
    updateSurcharge(surcharge, index) {
      this.index_surcharge = index;
      this.surcharge = Object.assign({}, surcharge);
      this.openModalEditSurcharge = !this.openModalEditSurcharge;
    },
    async deleteSurchargeById(surchargeId, index) {
      try {
        let { data } = await endpoint.surcharges.services.deleteSurchargeById(
          surchargeId,
          this.sesion.token
        );
        if (data) {
          this.surcharges.splice(index, 1);
          this.surchargesLimit.splice(index, 1);
          this.rate.surcharges = this.surcharges.map(
            surcharge => surcharge._id
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The extra surcharge event has been deleted successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The extra surcharge event cannot be deleted",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteSurcharge(surchargeId, index) {
      let { value } = await Swal.fire({
        title: "Delete extra charge",
        text: "Are you sure do you want delete this extra charge?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes"
      });
      if (value) {
        await this.deleteSurchargeById(surchargeId, index);
      }
    },
    addSurchargeEvent: function(payload) {
      try {
        let { surcharge } = payload;
        this.openModalAddSurcharge = false;
        this.surcharges.push(surcharge);
        this.surchargesLimit.push({
          _id: surcharge._id,
          type: surcharge.type
        });
        this.rate.surcharges = this.surcharges.map(surcharge => surcharge._id);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The extra surcharge event has been saved successfully",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    editSurchargeEvent: function(payload) {
      try {
        let { surcharge } = payload;
        this.openModalEditSurcharge = false;
        this.surcharges.splice(this.index_surcharge, 1, surcharge);
        this.surchargesLimit.splice(this.index_surcharge, 1, {
          _id: surcharge._id,
          type: surcharge.type
        });
        this.surcharge = null;
        this.index_surcharge = -1;
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The extra surcharge event has been updated successfully",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    parseAreaOfAction(areas = []) {
      return areas
        .filter(area => area.polygon !== "")
        .map(area => {
          return {
            price: area.price,
            polygon: area.polygon,
            price_extra_km: area.price_extra_km
          };
        });
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async getSettings(operatorId) {
      try {
        let { data } = await endpoint.settings.services.getSettings(
          operatorId,
          this.sesion.token
        );
        if (data.status) {
          let settings = data.data;
          this.tempUnit =
            settings.global_info.measurement_unit === "km" ? "Km" : "Milles";
        } else {
          this.tempUnit = "Km";
        }
      } catch (error) {
        this.tempUnit = "Km";
      }
    },
    async getVehiclesByBranchId(branchId) {
      try {
        let { data } = await endpoint.vehicles.services.getVehiclesByBranchId(
          branchId,
          this.sesion.token
        );
        return data;
      } catch (error) {
        return [];
      }
    },
    async getAreasOptionsByBranchId(branchId) {
      try {
        let { data } = await endpoint.areas.services.getAreasOptionsByBranchId(
          branchId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    populateVehicles(vehicles = []) {
      return vehicles.map(vehicle => {
        return {
          especifications: vehicle.especifications,
          information: vehicle.information,
          insurance: vehicle.insurance,
          owner: vehicle.owner,
          parameters: vehicle.parameters,
          relationship: vehicle.relationship,
          scheduled: vehicle.scheduled,
          soft_delete: vehicle.soft_delete,
          timezone: vehicle.timezone,
          _id: vehicle._id
        };
      });
    },
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(vehicles) {
      if (vehicles.length > 0) {
        this.selectedRows = vehicles;
        this.rate.vehicles = vehicles.map(vehicle => vehicle._id);
        let [item] = vehicles;
        if (item) {
          this.rate.vehicle = item._id;
          this.vehicle = {
            n_seats: item.vehicle.parameters.n_seats,
            n_suitcases: item.vehicle.parameters.n_suitcases,
            url: item.vehicle.information.image,
            category: item.vehicle.parameters.category,
            name: item.vehicle.parameters.name
          };
        }
      } else {
        this.rate.vehicle = null;
        this.rate.vehicles = [];
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectRowByIndex(indexs = []) {
      for (let index = 0; index < indexs.length; index++) {
        this.$refs.selectableTable.selectRow(indexs[index]);
      }
    },
    getIndexs(vehicleIds = [], vehicles = []) {
      return vehicleIds.map(vehicleId => {
        return vehicles.findIndex(vehicle => {
          return vehicle._id === vehicleId;
        });
      });
    },
    async detectChanges(to, from, next) {
      if (!this.sigout) {
        let isEqual = lodash.isEqual(this.rate, this.rateCopy);
        if (!isEqual && !this.saved) {
          let { value, dismiss } = await Swal.fire({
            title: "Important",
            html:
              "The Rate has been modified, <br>  do you want to save changes?",
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
            buttonsStyling: false,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            reverseButtons: true,
            cancelButtonText: "No",

            confirmButtonText: "Yes",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (value) {
            this.saveRates(to.path);
          } else if (dismiss === Swal.DismissReason.cancel) {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    },
    getDescriptionByAreaId(areaId) {
      let area = this.areas.find(area => area._id === areaId);
      if (area) {
        return area.description;
      } else {
        return "";
      }
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    getNameAreas(areaId) {
      let area = this.areas.find(area => area._id === areaId);
      if (area) {
        return area.code;
      } else {
        return "";
      }
    },
    validateOverviwe(rate) {
      return (
        rate.branch.$invalid || rate.vehicle.$invalid || rate.vehicles.$invalid
      );
    },
    validatePricing(rate) {
      let rateParameters =
        rate.base_price.$invalid ||
        rate.currency_code.$invalid ||
        rate.price_extra_km.$invalid;
      let hourly =
        rate.hours_disposition.min_hours.$invalid ||
        rate.hours_disposition.price_by_hour.$invalid ||
        rate.hours_disposition.km_include.$invalid;

      let childSeat =
        rate.child_seat.number.$invalid || rate.child_seat.price.$invalid;
      let meetAndGreet = rate.meet_greet_price.$invalid;
      return rateParameters || hourly || childSeat || meetAndGreet;
    },
    validateServiceArea(rate) {
      return rate.area_of_action.$invalid;
    },
    validateSettings(rate) {
      return (
        rate.validity_date.$invalid ||
        rate.cancellationPolicy.$invalid ||
        rate.keyDetails.$invalid ||
        rate.termsConditions.$invalid
      );
    },
    validateRate(rate) {
      return {
        overviwe: this.validateOverviwe(rate),
        pricing: this.validatePricing(rate),
        areas: this.validateServiceArea(rate),
        settings: this.validateSettings(rate)
      };
    },
    goToTab(overviwe, pricing, areas, settings) {
      if (overviwe) {
        this.tabActive = "Overview";
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "Please complete the required attributes in the tab Overview",
          icon: "flaticon-warning-1"
        });
      } else if (pricing) {
        this.tabActive = "Pricing";
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes in the tab Pricing",
          icon: "flaticon-warning-1"
        });
      } else if (areas) {
        this.tabActive = `Service Areas (${this.rate.area_of_action.length})`;
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "Please complete the required attributes in the tab Services Areas",
          icon: "flaticon-warning-1"
        });
      } else if (settings) {
        this.tabActive = "Settings";
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "Please complete the required attributes in the tab Settings",
          icon: "flaticon-warning-1"
        });
      }
    },
    createArea(area) {
      if (this.rate.branch) {
        let isDuplicate = this.areaIsDuplicate(
          area.polygon,
          this.rate.area_of_action
        );
        if (isDuplicate) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "This area already exists in the list",
            icon: "flaticon-warning-1"
          });
          this.showNewAreaModal = false;
        } else {
          this.showNewAreaModal = false;
          this.rate.area_of_action.push(area);
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please select a destination",
          icon: "flaticon-warning-1"
        });
      }
    },
    addNewArea() {
      if (this.rate.branch) {
        this.showNewAreaModal = true;
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please select a destination",
          icon: "flaticon-warning-1"
        });
      }
    },
    closeNewAreaModal(status) {
      this.showNewAreaModal = status;
    },
    closeEditAreaModal(status) {
      this.showEditAreaModal = status;
      this.area = null;
    },
    editArea(area, areaIndex) {
      if (areaIndex > -1 && area) {
        this.area = area;
        this.areaIndex = areaIndex;
        this.showEditAreaModal = true;
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    updateArea(area) {
      if (this.areaIndex > -1 && area) {
        this.rate.area_of_action.splice(this.areaIndex, 1, area);
        this.area = null;
        this.areaIndex = -1;
        this.showEditAreaModal = false;
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The area has been updated successfully",
          icon: "flaticon-check-3"
        });
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    changeMode(mode) {
      this.mode = mode;
      if (mode === "edit") {
        setTimeout(() => {
          this.selectRowByIndex(
            this.getIndexs(this.rate.vehicles, this.vehicleList)
          );
        }, 100);
      }
    },
    async changeSurchargeStatus(surchargeId, status, index) {
      let { value } = await Swal.fire({
        title: "Change Status",
        text: `Are you sure do you want change status of the selected extra?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        let statusChanged = await this.changeSurchargeStatusById(
          surchargeId,
          status
        );
        if (statusChanged) {
          this.surcharges[index].status = status;
          this.$notify({
            type: "success",
            title: "Success!",
            message: status
              ? "This extra has been enabled"
              : "This extra has been disabled",
            icon: "flaticon-check-mark"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      }
    },
    async changeSurchargeStatusById(surchargeId, status) {
      try {
        let {
          data
        } = await endpoint.surcharges.services.updateAnyAttributeById(
          surchargeId,
          { status: status },
          this.sesion.token
        );
        return data ? data : null;
      } catch (error) {
        return null;
      }
    },
    async deleteArea(index) {
      let { value } = await Swal.fire({
        title: "Delete Service Area",
        text: "Are you sure do you want to delete this Service Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes"
      });
      if (value) {
        this.setLoad(true);
        this.rate.area_of_action.splice(index, 1);
        this.setLoad(false);
      }
    },
    getIndexByAreaId(areaId, areas = []) {
      return areas.map(area => area.polygon).indexOf(areaId);
    },
    areaIsDuplicate(areaId, areas = []) {
      let area = areas.find(area => area.polygon === areaId);
      if (area) {
        return true;
      } else {
        return false;
      }
    },
    getSurchargeById(surchargeId, surcharges = []) {
      return surcharges.map(surcharge => surcharge._id).indexOf(surchargeId);
    },
    isPositiveNumber(value) {
      let number = parseFloat(value);
      return !isNaN(number) && number >= 0;
    },
    getClassByRateStatus(status) {
      if (status === "ACTIVE") {
        return "status-confirmed";
      } else if (status === "INACTIVE") {
        return "status-cancelled";
      } else if (status === "EXPIRED") {
        return "status-draft";
      } else {
        return {};
      }
    },
    getIconByRateStatus(status) {
      if (status === "ACTIVE") {
        return "flaticon-bold-check-3 text-success";
      } else if (status === "INACTIVE") {
        return "flaticon-bold-cancel text-danger";
      } else if (status === "EXPIRED") {
        return "flaticon-time-left";
      } else {
        return {};
      }
    },
    changeRateStatus(status) {
      this.rate.status = status ? "ACTIVE" : "INACTIVE";
    },
    mustBeAfterNow(date) {
      let today = moment().utc(true);
      return moment(date).isSameOrAfter(today, "day");
    },
    mustBeAfterDate(startDate, endDate) {
      return moment(endDate).diff(startDate, "days") >= 1;
    },
    getDate(date) {
      return moment.utc(date).format("YYYY-MM-DD");
    },
    getDateFormat(date) {
      return moment.utc(date, "YYYY-MM-DD").format("DD-MMM-YYYY");
    },
    changetValidityStartDate(date) {
      if (this.rate.status === "EXPIRED") {
        let today = moment().utc(true);
        let isSameOrAfter = moment(moment(date).utc(true)).isSameOrAfter(
          today,
          "days"
        );
        if (isSameOrAfter) {
          this.rate.status = "ACTIVE";
        }
      }
    },
    closeSurchargeModal() {
      this.openModalAddSurcharge = false;
      this.openModalEditSurcharge = false;
    },
    hasSurchargeTimeRange,
    isThereAnExpirationDate(type) {
      return ["blackouts", "special_event", "seasonal"].indexOf(type) > -1;
    },
    getFormatDate(date) {
      return moment(date)
        .utc(true)
        .format("DD-MMM-YYYY");
    },
    getUnitFormatToLabel(value) {
      if (value === "HOURS") {
        return "Hours";
      } else if (value === "DAYS") {
        return "Days";
      } else if (value === "MINUTES") {
        return "Minutes";
      } else {
        return "H-D-M";
      }
    },
    getUnitFormat(unit, cutoff) {
      if (unit === "HOURS") {
        return cutoff === 1 ? "Hour" : "Hours";
      } else if (unit === "DAYS") {
        return cutoff === 1 ? "Day" : "Days";
      } else {
        return cutoff === 1 ? "Minute" : "Minutes";
      }
    },
    removeCancellation(index) {
      this.rate.cancellationPolicy.refundEligibility.splice(index, 1);
    },
    addCancellationPolicy() {
      this.rate.cancellationPolicy.refundEligibility.push({
        type: "",
        unit: "DAYS",
        cutoff: 1,
        percent: 0
      });
    },
    getDescription(cancellationPolicy) {
      if (cancellationPolicy.type === "FULL_REFUND") {
        return `To receive a Full Refund, cancellations must be made at least ${
          cancellationPolicy.cutoff
        } ${this.getUnitFormat(
          cancellationPolicy.unit,
          cancellationPolicy.cutoff
        )} prior to the start time of the experience.`;
      } else if (cancellationPolicy.type === "NO_REFUND") {
        return `If you cancel less than ${
          cancellationPolicy.cutoff
        } ${this.getUnitFormat(
          cancellationPolicy.unit,
          cancellationPolicy.cutoff
        )} before the experience's start time, the amount you paid will not be refunded.`;
      } else if (cancellationPolicy.type === "PARTIAL_REFUND") {
        return `To receive a ${
          cancellationPolicy.percent
        } % refund, cancellations must be made at least ${
          cancellationPolicy.cutoff
        } ${this.getUnitFormat(
          cancellationPolicy.unit,
          cancellationPolicy.cutoff
        )} prior to the start time of the experience.`;
      } else if (cancellationPolicy.type === "CHANGES") {
        return `Changes made less than ${
          cancellationPolicy.cutoff
        } ${this.getUnitFormat(
          cancellationPolicy.unit,
          cancellationPolicy.cutoff
        )} before the experience's start time will not be accepted.`;
      } else if (cancellationPolicy.type === "NON_REFUNDABLE") {
        return "This experience is Non-Refundable. If you cancel, the amount paid will not be refunded.";
      } else {
        return "";
      }
    },
    selectPolicy(cancellationPolicy) {
      if (cancellationPolicy.type.$model === "FULL_REFUND") {
        cancellationPolicy.percent.$model = 100;
      } else {
        cancellationPolicy.percent.$model = 0;
      }
      this.addRefundItem(this.rate.cancellationPolicy.refundEligibility);
    },
    formatEventType(type) {
      if (type === "blackouts") {
        return "Blackouts Dates";
      } else if (type === "special_event") {
        return "Special Event";
      } else if (type === "weekend_dates") {
        return "Weekend Fees";
      } else if (type === "night_fees") {
        return "Night Fees";
      } else if (type === "seasonal") {
        return "Seasonal Fees";
      }
    },
    formatCatergory(type) {
      if (type === "business") {
        return "Business";
      } else if (type === "luxury") {
        return "Luxury";
      } else {
        return "Standard";
      }
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    formatSurcharge(type) {
      if (type === "percentage") {
        return "%";
      } else {
        return "$";
      }
    },
    formatRateType(type) {
      if (type === "travel") {
        return "By Distance";
      } else {
        return "Area + Distance";
      }
    },
    formatRateStatus(status) {
      if (status === "ACTIVE") {
        return "Active";
      } else if (status === "INACTIVE") {
        return "Inactive";
      } else if (status === "EXPIRED") {
        return "Expired";
      } else {
        return "Unknow";
      }
    },
    populateCancellationPolicy(vehicleType) {
      if (
        [
          "sedan",
          "suvs",
          "limousine",
          "minivan",
          "premium_sedans",
          "pickup",
          "boat"
        ].includes(vehicleType)
      ) {
        return this.getRefundEligibilityForSmallVehicles();
      } else if (
        ["midicoach", "mpv", "minibus", "coach"].includes(vehicleType)
      ) {
        return this.getRefundEligibilityForBigVehicles();
      } else {
        return [];
      }
    },
    getRefundEligibilityForSmallVehicles() {
      return [
        {
          type: "FULL_REFUND",
          unit: "DAYS",
          cutoff: 1,
          percent: 100
        },
        {
          type: "PARTIAL_REFUND",
          unit: "HOURS",
          cutoff: 12,
          percent: 50
        },
        {
          type: "NO_REFUND",
          unit: "HOURS",
          cutoff: 12,
          percent: 0
        }
      ];
    },
    getRefundEligibilityForBigVehicles() {
      return [
        {
          type: "FULL_REFUND",
          unit: "DAYS",
          cutoff: 2,
          percent: 100
        },
        {
          type: "PARTIAL_REFUND",
          unit: "DAYS",
          cutoff: 1,
          percent: 50
        },
        {
          type: "NO_REFUND",
          unit: "DAYS",
          cutoff: 1,
          percent: 0
        }
      ];
    },
    getItemsDescriptionByRefundEligibility(refundEligibility = []) {
      return refundEligibility.map(item => {
        return this.getDescription(item);
      });
    },
    sortRefundEligibility(refundEligibility = []) {
      return refundEligibility.sort((a, b) => {
        if (
          this.convertTimeUnits(a.unit, a.cutoff) >
          this.convertTimeUnits(b.unit, b.cutoff)
        ) {
          return -1;
        }
        if (
          this.convertTimeUnits(a.unit, a.cutoff) <
          this.convertTimeUnits(b.unit, b.cutoff)
        ) {
          return 1;
        }
        return 0;
      });
    },
    convertTimeUnits(unit, value) {
      if (unit === "MINUTES") {
        return value / 60;
      } else if (unit === "DAYS") {
        return value * 24;
      } else {
        return value;
      }
    },
    selectNonRefundable(value) {
      if (value) {
        this.rate.cancellationPolicy.refundEligibility = this.rate.cancellationPolicy.refundEligibility.filter(
          item => {
            return item.type === "CHANGES";
          }
        );
        this.rate.cancellationPolicy.refundEligibility.push({
          type: "NON_REFUNDABLE",
          unit: "DAYS",
          cutoff: 1,
          percent: 0
        });
      } else {
        this.rate.cancellationPolicy.refundEligibility = this.rate.cancellationPolicy.refundEligibility.filter(
          item => {
            return item.type !== "NON_REFUNDABLE";
          }
        );
      }
    },
    getItemDisable(item, cancellationPolicy) {
      if (cancellationPolicy.nonRefundable) {
        if (item.value !== "CHANGES") {
          return true;
        } else {
          return cancellationPolicy.refundEligibility
            .map(e => e.type)
            .includes("CHANGES");
        }
      } else {
        if (["CHANGES", "FULL_REFUND"].includes(item.value)) {
          return cancellationPolicy.refundEligibility
            .map(e => e.type)
            .includes(item.value);
        } else {
          return false;
        }
      }
    },
    selectCurrencyCode(currencyCode) {
      let currency = this.coins.find(element => element.code === currencyCode);
      if (currency) {
        this.rate.currency_symbol = currency.symbol;
        this.rate.currency_label = currency.label;
      }
    },
    getRefunds(eligibilities = []) {
      return eligibilities.filter(eligibility => {
        return (
          ["FULL_REFUND", "PARTIAL_REFUND"].includes(eligibility.type) &&
          eligibility.unit &&
          eligibility.cutoff > 0
        );
      });
    },
    getMinRefundEligibility(eligibilities = []) {
      return eligibilities.reduce((minItem, currentItem) => {
        return this.convertTimeUnits(currentItem.unit, currentItem.cutoff) <
          this.convertTimeUnits(minItem.unit, minItem.cutoff)
          ? currentItem
          : minItem;
      });
    },
    addRefundItem(eligibilities = []) {
      let refunds = this.getRefunds(eligibilities);
      if (refunds.length) {
        let refund = this.getMinRefundEligibility(refunds);
        this.rate.cancellationPolicy.refundEligibility = this.rate.cancellationPolicy.refundEligibility.filter(
          item => item.type !== "NO_REFUND"
        );
        this.rate.cancellationPolicy.refundEligibility.push({
          type: "NO_REFUND",
          unit: refund.unit,
          cutoff: refund.cutoff,
          percent: 0
        });
      }
    },
    selectUnit() {
      this.addRefundItem(this.rate.cancellationPolicy.refundEligibility);
    },
    selectCutoff() {
      this.addRefundItem(this.rate.cancellationPolicy.refundEligibility);
    },
    selectPercent() {
      this.addRefundItem(this.rate.cancellationPolicy.refundEligibility);
    },
    getStatusHourlyRate(value) {
      return value ? "Active" : "Inactive";
    },
    ...mapActions(["getBranchesOptions"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setRatesSearchCriteria"
    ])
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [Card.name]: Card,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    SurchargeForm,
    NewArea: NewArea,
    EditArea: EditArea,
    WSelect,
    flatPicker,
    draggable
  },
  computed: {
    ...mapGetters([
      "branchesOptions",
      "vehiclesByBranchId",
      "sesion",
      "sigout",
      "settings",
      "ratesSearchCriteria"
    ]),
    globalUnit: function() {
      if (this.settings) {
        return this.settings.measurementUnit === "km" ? "Km" : "Milles";
      } else {
        return "Km";
      }
    },
    localUnit: function() {
      return this.sesion.role === "admin" ? this.tempUnit : this.globalUnit;
    },
    vehicleList: function() {
      return this.vehiclesOptions.map(vehicle => {
        return {
          _id: vehicle._id,
          category: vehicle.parameters.category,
          type: vehicle.parameters.type,
          model: vehicle.parameters.name,
          seats: vehicle.parameters.n_seats,
          bags: vehicle.parameters.n_suitcases,
          vehicle: vehicle
        };
      });
    },
    areasOptions: function() {
      return this.rate.area_of_action.map(area => {
        return {
          _id: area.polygon,
          areaCode: this.getNameAreas(area.polygon),
          description: this.getDescriptionByAreaId(area.polygon),
          baseprice: area.price,
          priceextra: area.price_extra_km,
          area: area
        };
      });
    },
    surchargesOptions: function() {
      return this.surcharges.map(surcharge => {
        return {
          _id: surcharge._id,
          event: surcharge.type,
          description: surcharge.description,
          value:
            surcharge.type !== "blackouts" ? surcharge.markup.value : "N/A",
          markupType:
            surcharge.type !== "blackouts" ? surcharge.markup.type : "N/A",
          from: surcharge.from_date,
          end: surcharge.to_date,
          status: surcharge.status ? "Active" : "Inactive",
          surcharge: surcharge
        };
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInRatesModule(
      to.meta.modules,
      this.setRatesSearchCriteria,
      "rates"
    );
    this.detectChanges(to, from, next);
  },
  validations() {
    return {
      rate: {
        branch: {
          required
        },
        vehicle: {
          required
        },
        vehicles: {
          required,
          $each: {}
        },
        hand_luggage: {
          decimal,
          minValue: minValue(1)
        },
        base_price: {
          required,
          decimal,
          minValue: minValue(1)
        },
        currency_code: {
          required
        },
        price_extra_km: {
          required,
          decimal,
          minValue: minValue(1)
        },
        hours_disposition: {
          status: {
            required
          },
          min_hours: {
            required: requiredIf(function(value) {
              return this.rate.hours_disposition.status;
            }),
            minValue: minValue(1),
            maxValue: maxValue(12)
          },
          max_hours: {
            required: requiredIf(function(value) {
              return this.rate.hours_disposition.status;
            }),
            numeric,
            minValue: minValue(
              this.rate.hours_disposition.min_hours
                ? this.rate.hours_disposition.min_hours
                : 1
            ),
            maxValue: maxValue(24)
          },
          price_by_hour: {
            required: requiredIf(function(value) {
              return this.rate.hours_disposition.status;
            }),
            decimal,
            minValue: minValue(1)
          },
          km_include: {
            required: requiredIf(function(value) {
              return this.rate.hours_disposition.status;
            }),
            numeric,
            minValue: minValue(1)
          }
        },
        child_seat: {
          price: {
            decimal,
            isPositiveNumber: function(value) {
              return this.isPositiveNumber(value);
            }
          },
          number: {
            numeric,
            isPositiveNumber: function(value) {
              return this.isPositiveNumber(value);
            }
          }
        },
        preference: {
          wifi: {},
          water: {},
          newspaper: {},
          hand_sanitizer: {}
        },
        meet_greet_price: {
          decimal,
          isPositiveNumber: function(value) {
            return this.isPositiveNumber(value);
          }
        },
        area_of_action: {
          required: requiredIf(function(value) {
            return this.selectionRate !== "travel";
          }),
          $each: {
            price: {
              required,
              decimal
            },
            polygon: {
              required
            },
            price_extra_km: {
              required,
              decimal
            }
          }
        },
        status: {
          required
        },
        validity_date: {
          start: {
            required,
            isExpired: function(value) {
              return !(this.rate.status === "EXPIRED");
            },
            customValidator: function(value) {
              if (this.rate.status === "EXPIRED") {
                return this.mustBeAfterNow(value);
              } else {
                if (
                  this.lastStatus === "EXPIRED" &&
                  this.rate.status !== "EXPIRED"
                ) {
                  return this.mustBeAfterNow(value);
                } else {
                  return moment
                    .utc(value)
                    .isSameOrAfter(
                      moment.utc(this.lastValidityStartDate),
                      "days"
                    );
                }
              }
            },
            isSameOrAfter: function(value) {
              return moment
                .utc(value)
                .isSameOrAfter(moment.utc(this.lastValidityStartDate), "days");
            }
          },
          end: {
            required,
            isExpired: function(value) {
              return !(this.rate.status === "EXPIRED");
            },
            mustBeAfterNow: function(value) {
              return this.mustBeAfterNow(value);
            },
            customValidator: function(value) {
              return this.mustBeAfterDate(this.rate.validity_date.start, value);
            }
          }
        },
        cancellationPolicy: {
          type: {
            required
          },
          refundEligibility: {
            required: requiredIf(function(value) {
              return !this.rate.cancellationPolicy.nonRefundable;
            }),
            $each: {
              type: {
                required
              },
              unit: {
                required
              },
              cutoff: {
                required,
                numeric,
                minValue: minValue(1)
              },
              percent: {
                required,
                numeric,
                isValidPercent: function(value, context) {
                  if (context.type === "FULL_REFUND") {
                    return value === 100;
                  } else if (context.type === "PARTIAL_REFUND") {
                    return value >= 1 && value <= 100;
                  } else if (context.type === "NO_REFUND") {
                    return value === 0;
                  } else {
                    return true;
                  }
                }
              }
            }
          }
        },
        advancedReservation: {
          unit: {
            required
          },
          cutoff: {
            required,
            numeric,
            minValue: minValue(1)
          }
        },
        keyDetails: {
          minLength: minLength(10),
          maxLength: maxLength(1500)
        },
        termsConditions: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(1500)
        }
      }
    };
  }
};
</script>
